export default Vue.component('zipcode-input', {
	template: `
		<div>
			<label v-if="label" class="control-label" :for="name">{{ label }}</label>
			<input ref="el" @focus="emit('focus')" class="form-control" :name="name" :id="name" :value="value" @input="updateValue($event.target.value)" @blur="formatValue">
		</div>
	`,
	props: {
		value: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: 'zipcode'
		}
	},
	mounted() {
		this.formatValue();
	},
	updated() {
		this.formatValue();
	},
	methods: {
		emit(emitter) {
			this.$emit(emitter, this.value);
		},
		updateValue(value) {
			let zipcode = this.formatZip(value);
			
			this.$refs.el.value = zipcode;
			this.$emit('input', zipcode);
		},
		formatValue() {
			this.$refs.el.value = this.formatZip(this.value);
			this.$emit('blur', this.value);
		},
		formatZip(value) {
			let zipcode = _.replace(value, /\D/g, '');
			zipcode = zipcode.toString().slice(0, 9);
			
			if (zipcode.length <= 5) {
				return zipcode;
			}
			
			let begin = zipcode.toString().slice(0, 5);
			let end = zipcode.toString().slice(5);
			
			return begin + '-' + end;
		}
	}
});